import { Card, CardBody, CardHead } from "@/components/admin/card";

export function ProfilePreferencesPage() {
	return (
		<Card>
			<CardHead
				title="Préférences"
				sub="Cosmétique uniquement pour l'instant — phase 2"
			/>
			<CardBody>
				<div className="info-row">
					<span className="l">Densité d'affichage des tableaux</span>
					<span className="v">
						<select
							className="aform-i"
							style={{ width: 160 }}
							defaultValue="dense"
						>
							<option value="dense">Dense (défaut)</option>
							<option value="comfortable">Confortable</option>
						</select>
					</span>
				</div>
				<div className="info-row">
					<span className="l">Format de date</span>
					<span className="v">
						<select
							className="aform-i"
							style={{ width: 160 }}
							defaultValue="fr"
						>
							<option value="fr">jj/mm/aaaa</option>
							<option value="iso">aaaa-mm-jj</option>
						</select>
					</span>
				</div>
				<div className="info-row" style={{ borderBottom: "none" }}>
					<span className="l">Notifications par email</span>
					<span className="v">
						<input type="checkbox" defaultChecked /> Activées
					</span>
				</div>
			</CardBody>
		</Card>
	);
}
